/** Public marketing paths — skip /auth/me when anonymous to avoid 401 + latency. */
export function isPublicMarketingPath(pathname) {
  const path = pathname || '/';
  if (path === '/') return true;
  const prefixes = [
    '/contact',
    '/faq',
    '/pricing',
    '/how-it-works',
    '/shipping-calculator',
    '/package-forwarding',
    '/personal-shopper',
    '/fulfillment',
    '/blog',
    '/shop-from-india-',
    '/legal/',
  ];
  return prefixes.some((p) => path === p || path.startsWith(p));
}
